// @ts-strict-ignore
import { IconStaticBrandFacebook } from "@hubble/icons";
import { Flex, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const FacebookIconStatic = styled(IconStaticBrandFacebook)`
  path {
    fill: #fff;
  }
`;

export const SocialShareModalContent = styled(Flex)`` as typeof Flex;

export const SocialShareModalIconsWrapper = styled.div`
  margin: auto;

  @media ${mediaQuery.mobileXsDown} {
    margin: 0;
    // 24px*2(for padding of modal content container) + 2px(for scroll width)
    max-width: calc(100vw - 50px);
  }
`;

export const SocialShareButtonsContainer = styled(Flex)`
  justify-content: center;

  @media ${mediaQuery.mobileXsDown} {
    justify-content: flex-start;
  }
` as typeof Flex;
